export default {
  default: () => import("/home/jetmix/production/storebusters-landing/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/home/jetmix/production/storebusters-landing/layouts/empty.vue").then(m => m.default || m)
}